/* Mckwurst Designs custom orders form: inline validation and the big-order / short-deadline notice.
   No dependencies. The form posts to Shopify's contact endpoint either way, so without script the
   browser and the server still check the required fields. With script, each problem is named next to
   its field (aria-invalid plus aria-describedby), focus lands on the first one, and the notice appears
   for a quantity over 20 (read from free text) or an in-hand date under 3 weeks away. */
(function () {
  'use strict';

  var BIG_ORDER = 20;
  var SHORT_NOTICE_DAYS = 21;
  var DAY_MS = 86400000;

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* Local midnight today. Date-only strings parse as UTC, so build the dates from parts. */
  function today() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function parseDate(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;
    var date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (date.getMonth() !== Number(match[2]) - 1) return null;
    return date;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function isoToday() {
    var t = today();
    return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
  }

  function setError(field, message) {
    var input = field.querySelector('input, textarea, select');
    var error = field.querySelector('[data-error]');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
    if (input) {
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  /* Returns the message for a field, or an empty string when it is fine. */
  function check(field) {
    var input = field.querySelector('input, textarea, select');
    if (!input) return '';
    var value = input.value.trim();
    var type = field.getAttribute('data-type');
    if (field.hasAttribute('data-required') && value === '') return field.getAttribute('data-message');
    if (value === '') return '';
    if (type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return field.getAttribute('data-invalid-message') || field.getAttribute('data-message');
    }
    if (type === 'tel' && value.replace(/\D/g, '').length < 7) return field.getAttribute('data-message');
    if (type === 'date') {
      var date = parseDate(value);
      if (!date || date < today()) return field.getAttribute('data-message');
    }
    return '';
  }

  function initForm(form) {
    if (form.hasAttribute('data-inited')) return;
    form.setAttribute('data-inited', '');
    form.noValidate = true;

    var fields = all(form, '[data-co-field]');
    var quantity = form.querySelector('[data-co-quantity]');
    var dateInput = form.querySelector('[data-co-date]');
    var notice = form.querySelector('[data-co-notice]');
    var summary = form.querySelector('[data-co-summary]');

    if (dateInput) dateInput.min = isoToday();

    /* The notice region exists before it has text, so assistive technology announces the change. */
    function updateNotice() {
      if (!notice) return;
      var big = false;
      var short = false;
      if (quantity) {
        /* Free text such as "about 30": read the first whole number in it. */
        var found = /\d+/.exec(quantity.value);
        big = found !== null && parseInt(found[0], 10) > BIG_ORDER;
      }
      if (dateInput) {
        var date = parseDate(dateInput.value);
        if (date && date >= today()) short = Math.round((date - today()) / DAY_MS) < SHORT_NOTICE_DAYS;
      }
      var text = '';
      if (big && short) text = notice.getAttribute('data-both-text');
      else if (big) text = notice.getAttribute('data-quantity-text');
      else if (short) text = notice.getAttribute('data-date-text');
      if (notice.textContent !== text) notice.textContent = text;
      notice.classList.toggle('has-text', Boolean(text));
    }

    fields.forEach(function (field) {
      var input = field.querySelector('input, textarea, select');
      if (!input) return;
      input.addEventListener('blur', function () {
        if (input.value.trim() === '' && !field.hasAttribute('data-required')) return;
        setError(field, check(field));
      });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') setError(field, check(field));
      });
    });

    [quantity, dateInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', updateNotice);
      input.addEventListener('change', updateNotice);
    });

    var fullName = form.querySelector('[data-co-fullname]');
    var firstName = form.querySelector('#CustomOrder-first-name');
    var lastName = form.querySelector('#CustomOrder-last-name');

    /* The region exists before it has text, so the count is announced when it appears. */
    function showSummary(count) {
      if (!summary) return;
      var template = count === 1 ? summary.getAttribute('data-text-one') : summary.getAttribute('data-text-other');
      summary.textContent = count ? String(template || '').split('__COUNT__').join(count) : '';
    }

    form.addEventListener('submit', function (event) {
      var first = null;
      var problems = 0;
      if (fullName && firstName && lastName) {
        fullName.value = (firstName.value.trim() + ' ' + lastName.value.trim()).trim();
      }
      fields.forEach(function (field) {
        var message = check(field);
        setError(field, message);
        if (message) problems += 1;
        if (message && !first) first = field.querySelector('input, textarea, select');
      });
      showSummary(problems);
      if (first) {
        event.preventDefault();
        first.focus();
      }
    });

    updateNotice();
  }

  function init(scope) {
    all(scope, '.co-form').forEach(initForm);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  init(document);
})();
